import React, { FC, useContext } from 'react';

import { Toggle } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

export const ClientRegister: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <>
      <Toggle
        onChange={(value: string) =>
          setSetting({
            alias: ESettingsAliases.CLIENT_REGISTER,
            value: value ? '1' : '0',
          })
        }
        emptyBg
        variant="secondary"
        description={t('settings.booking.operatorRegister.description')}
        value={settings.clientRegister}
        label={t('settings.booking.operatorRegister.title')}
      />
    </>
  );
};
